import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In order to generate optimized images that Gatsby can use, you need to `}<strong parentName="p">{`Query`}</strong>{` your image using GraphQL. Under the hood, this query is processed using `}<inlineCode parentName="p">{`gatsby-transformer-sharp`}</inlineCode>{`.`}</p>
    <p>{`When querying for a specific image you use the `}<inlineCode parentName="p">{`relativePath`}</inlineCode>{`. This path is relative to the path you configured for the `}<inlineCode parentName="p">{`gatsby-source-filesystem`}</inlineCode>{` plugin and should ultimately point to your image file.`}</p>
    <p>{`Inside the query you’ll notice `}<inlineCode parentName="p">{`fluid`}</inlineCode>{` and `}<inlineCode parentName="p">{`GatsbyImageSharpFluid`}</inlineCode>{` query terms. There are other `}<a parentName="p" {...{
        "href": "/packages/gatsby-image/#two-types-of-responsive-images"
      }}>{`types of image processing`}</a>{` you can prompt with your query which will alter both of those query terms.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      